"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var widgets_1 = require("@tableau/widgets");
var React = require("react");
var Localize_1 = require("../../../../gen-src/Localize");
var ComposeEmailDialogContent_1 = require("./ComposeEmailDialogContent");
var ComposeEmailDialogStyles_1 = require("./ComposeEmailDialogStyles");
function validateText(text, maximum) {
    if (text.length > maximum) {
        return 'overflow';
    }
    if (text.replace(/\s/g, '') === '') {
        return 'empty';
    }
    return 'valid';
}
var ComposeEmailDialogContainer = /** @class */ (function (_super) {
    __extends(ComposeEmailDialogContainer, _super);
    function ComposeEmailDialogContainer(props) {
        var _this = _super.call(this, props) || this;
        _this.handleBodyChange = function (event) {
            var bodyText = event.target.value;
            _this.setState(function (s, _) {
                var isBodyValid = validateText(bodyText, ComposeEmailDialogStyles_1.ComposeEmailDialogStyles.MAXIMUM_BODY_LENGTH);
                return __assign(__assign({}, s), { bodyText: bodyText, bodyValidity: isBodyValid });
            });
        };
        _this.handleSubjectChange = function (e) {
            var subjectText = e.target.value;
            _this.setState(function (s, _) {
                var isSubjectValid = validateText(subjectText, ComposeEmailDialogStyles_1.ComposeEmailDialogStyles.MAXIMUM_SUBJECT_LENGTH);
                return __assign(__assign({}, s), { subjectText: subjectText, subjectValidity: isSubjectValid });
            });
        };
        _this.invokeSubmit = function () {
            _this.setState({ isSubmitting: true }, function () { return _this.props.submitResult({
                bodyText: _this.state.bodyText,
                subjectText: _this.state.subjectText,
            }); });
        };
        _this.state = {
            isSubmitting: false,
            subjectText: '',
            bodyText: '',
            subjectValidity: 'initial',
            bodyValidity: 'initial',
        };
        return _this;
    }
    // TODO: Once we have the correct ReactModalService methods exposed via UIActions, use them so that we
    // get the correct styled props without having to declare them all by hand.
    ComposeEmailDialogContainer.prototype.dialogProps = function () {
        return {
            title: Localize_1.Messages.EmailDialogTitle(),
            dialogWidth: ComposeEmailDialogStyles_1.ComposeEmailDialogStyles.DIALOG_WIDTH,
            testId: ComposeEmailDialogStyles_1.ComposeEmailDialogStyles.TEST_ID('dialog'),
            isModal: true,
            handleGlassClick: this.props.dismissDialog,
            type: widgets_1.DialogType.NormalWithTitleBar,
            positioningBehavior: widgets_1.DialogPositioningBehavior.Centered,
            shouldAdjustPositionOnWindowResize: true,
            onCloseRequest: this.props.dismissDialog,
            showCloseButton: false,
            showFooter: true,
            footerContent: (React.createElement(ComposeEmailDialogContent_1.ComposeEmailDialogFooter, { dismissDialog: this.props.dismissDialog, invokeSubmit: this.invokeSubmit, isSubmitting: this.state.isSubmitting, isValid: this.state.bodyValidity === 'valid' && this.state.subjectValidity === 'valid' })),
        };
    };
    ComposeEmailDialogContainer.prototype.render = function () {
        return (React.createElement(widgets_1.DialogWidget, __assign({}, this.dialogProps()),
            React.createElement(ComposeEmailDialogContent_1.ComposeEmailDialogContent, { subjectValidity: this.state.subjectValidity, bodyValidity: this.state.bodyValidity, selectedUserIds: this.props.selectedUserIds, bodyText: this.state.bodyText, subjectText: this.state.subjectText, handleBodyChange: this.handleBodyChange, handleSubjectChange: this.handleSubjectChange })));
    };
    return ComposeEmailDialogContainer;
}(React.Component));
exports.ComposeEmailDialogContainer = ComposeEmailDialogContainer;
//# sourceMappingURL=ComposeEmailDialogContainer.js.map